import { Outlet } from 'react-router-dom';
import { Provider } from 'mobx-react';
import s from './index.module.scss';

import grtStore from '@/store/grtStore';
import withRouter from '@/components/withRouter';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/es/locale/zh_CN';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
dayjs.locale('zh-cn');
const WebLayout = () => {
    return (
        <ConfigProvider locale={zhCN}>
            <Provider store={grtStore}>
                <div className={[`grt-box grt-web-box ${s['web-wrap']}`]}>
                    <Outlet></Outlet>
                </div>
            </Provider>
        </ConfigProvider>
    );
};

export default withRouter(WebLayout);
